import Tooltips from "./tooltip";

const IconHover = ({ children, onClick, additionalclasses, position, content, command }) => {
    return (
        <Tooltips position={position} content={content} command={command}>
            <div onClick={onClick} className={`${additionalclasses} hover:custom-bg-white-50 rounded-[4px] transtion-all duration-300 w-fit cursor-pointer px-[5px] py-[5px]`} >
                {children}
            </div>
        </Tooltips>
    );
};

export default IconHover;